import '@ori-ui/license';
import createEmotionCache from '@emotion/cache';
import { CacheProvider as EmotionCacheProvider } from '@emotion/react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { memo, useMemo } from 'react';
import oriTheme from '../theme';
import { jsx as _jsx } from "react/jsx-runtime";
export function ThemeProvider({
  children,
  theme = oriTheme,
  enableCacheProvider,
  cacheKey,
  cacheOptions
}) {
  const internalTheme = useMemo(() => {
    if (typeof theme === 'function') {
      return theme(oriTheme);
    }

    return theme;
  }, [theme]);
  const options = useMemo(() => createEmotionCache({ ...cacheOptions,
    key: cacheKey ?? 'ori-ui'
  }), [cacheKey, cacheOptions]);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof cacheKey !== 'undefined' && enableCacheProvider !== true && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use cacheKey without enabling cache provider.`);
    }

    if (typeof cacheOptions !== 'undefined' && enableCacheProvider !== true && typeof window !== 'undefined') {
      console.error(`ORI-UI: You cannot use cacheOptions without enabling cache provider.`);
    }
  }

  if (!enableCacheProvider) {
    return _jsx(MuiThemeProvider, {
      theme: internalTheme,
      children: children
    });
  }

  return _jsx(EmotionCacheProvider, {
    value: options,
    children: _jsx(MuiThemeProvider, {
      theme: internalTheme,
      children: children
    })
  });
}
export default memo(ThemeProvider);